"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilePlayer = void 0;
const react_1 = __importStar(require("react"));
const util_1 = require("../../../util");
exports.FilePlayer = (0, react_1.forwardRef)((props, ref) => {
    const refX = (0, react_1.createRef)();
    (0, react_1.useImperativeHandle)(ref, () => ({
        seekTo(to) {
            if (refX.current) {
                refX.current.currentTime = to;
            }
        },
        getRawPlayer() {
            return refX.current;
        },
        play() {
            if (refX.current) {
                refX.current.play();
            }
        },
        pause() {
            if (refX.current) {
                refX.current.pause();
            }
        },
        getDuration() {
            if (refX.current) {
                return refX.current.duration;
            }
            return -1;
        },
        getCurrentTime() {
            if (refX.current) {
                return refX.current.currentTime;
            }
            return -1;
        },
    }));
    const { playerProps } = props;
    const { className, src, tracks, controls, poster, width, height, loop, autoplay, muted, crossorigin, preload, onEnded, onPause, onPlay, onStart, onDurationChange, onProgress, bottomRow, } = playerProps;
    const isSimpleSrc = typeof src === 'string';
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("video", { controls: controls, className: (0, util_1.cnx)('glx-media-player', className), ref: refX, src: isSimpleSrc ? src : undefined, poster: poster, width: width, height: height, loop: loop, muted: muted, autoPlay: autoplay, crossOrigin: crossorigin, onProgress: (event) => {
                const target = event.target;
                onProgress?.({
                    target,
                    currentTime: target.currentTime,
                    duration: target.duration,
                });
            }, onDurationChange: (event) => {
                const target = event.target;
                onDurationChange?.({
                    target,
                    currentTime: target.currentTime,
                    duration: target.duration,
                });
            }, onLoadedMetadata: () => {
                onStart?.();
            }, preload: preload, onEnded: () => {
                onEnded?.();
            }, onPause: () => {
                onPause?.();
            }, onPlay: () => {
                onPlay?.();
            } },
            !isSimpleSrc
                ? src.map((s) => react_1.default.createElement("source", { src: s.src, type: s.type }))
                : null,
            tracks?.map((track) => (react_1.default.createElement("track", { default: track.default, kind: track.kind, src: track.src, srcLang: track.srclang, label: track.label })))),
        bottomRow));
});
exports.FilePlayer.defaultProps = {
    ref: undefined,
};
